"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentErrorType = exports.PaymentErrorAction = void 0;
var PaymentErrorAction;
(function (PaymentErrorAction) {
    PaymentErrorAction["NO_ACTION"] = "NO_ACTION";
    PaymentErrorAction["RETRY_WITH_SAME_PROVIDER"] = "RETRY_WITH_SAME_PROVIDER";
    PaymentErrorAction["RETRY_WITH_DIFFERENT_PROVIDER"] = "RETRY_WITH_DIFFERENT_PROVIDER";
})(PaymentErrorAction || (exports.PaymentErrorAction = PaymentErrorAction = {}));
var PaymentErrorType;
(function (PaymentErrorType) {
    PaymentErrorType["FRAUD_SUSPECTED"] = "FRAUD_SUSPECTED";
    PaymentErrorType["BANK_REJECTION_AMOUNT_EXCEEDS_LIMIT"] = "BANK_REJECTION_AMOUNT_EXCEEDS_LIMIT";
    PaymentErrorType["ACTIVITY_AMOUNT_LIMIT_EXCEEDED"] = "ACTIVITY_AMOUNT_LIMIT_EXCEEDED";
    PaymentErrorType["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    PaymentErrorType["DECLINED_DO_NOT_HONOR"] = "DECLINED_DO_NOT_HONOR";
    PaymentErrorType["EXPIRED_CARD"] = "EXPIRED_CARD";
    PaymentErrorType["INVALID_CARD_DETAILS"] = "INVALID_CARD_DETAILS";
    PaymentErrorType["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
    PaymentErrorType["TRANSACTION_EXPIRED"] = "TRANSACTION_EXPIRED";
    PaymentErrorType["CARD_NOT_INITIALIZED"] = "CARD_NOT_INITIALIZED";
    PaymentErrorType["PIN_VALIDATION_FAILED"] = "PIN_VALIDATION_FAILED";
    PaymentErrorType["WITHDRAWAL_FREQUENCY_EXCEEDED"] = "WITHDRAWAL_FREQUENCY_EXCEEDED";
    PaymentErrorType["CARD_LOST_STOLEN"] = "CARD_LOST_STOLEN";
    PaymentErrorType["RESTRICTED_CARD"] = "RESTRICTED_CARD";
    PaymentErrorType["INVALID_MERCHANT"] = "INVALID_MERCHANT";
    PaymentErrorType["SECURITY_VIOLATION"] = "SECURITY_VIOLATION";
    PaymentErrorType["CARD_BLOCKED"] = "CARD_BLOCKED";
    PaymentErrorType["CARD_EXPIRED"] = "CARD_EXPIRED";
    PaymentErrorType["INCORRECT_CVC"] = "INCORRECT_CVC";
    PaymentErrorType["INCORRECT_CARD_NUMBER"] = "INCORRECT_CARD_NUMBER";
    PaymentErrorType["INCORRECT_ZIP_OR_ADDRESS"] = "INCORRECT_ZIP_OR_ADDRESS";
    PaymentErrorType["PROCESSING_ERROR"] = "PROCESSING_ERROR";
    PaymentErrorType["CARD_NOT_SUPPORTED"] = "CARD_NOT_SUPPORTED";
    PaymentErrorType["TRANSACTION_NOT_ALLOWED"] = "TRANSACTION_NOT_ALLOWED";
    PaymentErrorType["PICKUP_CARD"] = "PICKUP_CARD";
    PaymentErrorType["CARD_RATE_LIMIT_EXCEEDED"] = "CARD_RATE_LIMIT_EXCEEDED";
    PaymentErrorType["CURRENCY_NOT_SUPPORTED"] = "CURRENCY_NOT_SUPPORTED";
    PaymentErrorType["INVALID_ACCOUNT"] = "INVALID_ACCOUNT";
    PaymentErrorType["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    PaymentErrorType["INVALID_EXPIRY"] = "INVALID_EXPIRY";
    PaymentErrorType["STOLEN_CARD"] = "STOLEN_CARD";
    PaymentErrorType["WITHDRAWAL_LIMIT_EXCEEDED"] = "WITHDRAWAL_LIMIT_EXCEEDED";
    PaymentErrorType["CARD_DECLINED"] = "CARD_DECLINED";
    PaymentErrorType["API_ERROR"] = "API_ERROR";
    PaymentErrorType["AUTHENTICATION_REQUIRED"] = "AUTHENTICATION_REQUIRED";
    PaymentErrorType["OTHER"] = "OTHER";
})(PaymentErrorType || (exports.PaymentErrorType = PaymentErrorType = {}));
//# sourceMappingURL=payments.enum.js.map